export const FormControlList = {
    InputBox: 'InputBox',
    DropDownList: 'DropDownList',
    MultipleDropDownList: 'MultipleDropDownList',
    TreeSelect: 'TreeSelect',
    CheckBox: 'CheckBox',
    FileUpload: 'FileUpload',
    Picture: 'Picture',
    RadioButton: 'RadioButton',
    DatePicker: 'DatePicker',
    Rating: 'Rating',
    ToggleButton: 'ToggleButton'
}

export enum FormControlListIds {
    DropDownList = 1,
    CheckBox = 2,
    RadioButton = 3,
    ToggleButton = 4,
    Picture = 5,
    FileUpload = 6,
    Rating = 7,
    InputBox = 8,
    DatePicker = 9,
    MultipleDropDownList = 11,
}

export const CommaSeparatedControls = [FormControlList.InputBox,FormControlList.MultipleDropDownList,FormControlList.CheckBox];
